// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"847c80ae","305":"09272b9c","321":"11402107","453":"a0f569d6","464":"d7aa1319","492":"0184ac97","724":"5ebfd11f","906":"6e7aa6db","973":"fdcfdc07"}[chunkId] + ".chunk.js";
};